import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardHeader} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import {deleteData, getData} from '../../api/doLogin.js';
import {Calendar as BigCalendar, momentLocalizer} from "react-big-calendar";
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {displayMilHoursMinutesFromTime, forceUTCTimeZone, formatUTCTimeFromEpoch} from "../../util/datehelpers";
import {LoadingDialog} from "../../components/Shared/LoadingDialog";
import {EventClient} from "../../util/eventClient";
import {isNumber} from "../../util/numberhelpers";
import {MakeDialog} from "../../components/Shared/MakeDialog";
import EventEntryEditor from "./EventEntryEditor";
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";

//http://intljusticemission.github.io/react-big-calendar/examples/index.html#dnd

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

let localizer = momentLocalizer(moment)

// const DraggableBigCalendar = withDragAndDrop(BigCalendar);

export class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {},
      cal_id: 0,
      events: [],
      calendarList: [],
      chosenEvent: null,
      loading: true,
      dateRange: {
        start: 0,
        end: 0
      },
      fetchRange: {
        start: (Math.round((new Date()).getTime() / 1000)) - (60 * 24 * 3600),
        end: (Math.round((new Date()).getTime() / 1000)) + (60 * 24 * 3600)
      },
      currentDate: new Date(),
      currentView: 'month',
      showAddEventEntry: false,
      editID: null,
      addSelection: {}
    };
  }

  componentDidMount() {
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.computeDisplayedDateRange();
    this.updateData(this.state.fetchRange);
    EventClient.on("EVENT_REFRESH", () => this.updateData(), "Events")
  }

  componentWillUnmount() {
    EventClient.off("EVENT_REFRESH", () => this.updateData(), "Events")
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.chosenCalendar !== this.state.chosenCalendar) {
      this.updateData();
      return false;
    }
  }

  removeEvent(event) {
    const self = this;
    if (confirm(`Are you sure you want to remove the event ${event.title}?`)) {
      deleteData(`events/${event.id}`, {})
        .then((data) => {
          // console.log(data)
          if (data.status === "Success") {
            self.setState({showAddEventEntry: false, chosenEvent: null}, () => {
              EventClient.emit("EVENT_REFRESH");
            });
          }
        })
        .catch(() => {
          console.error(error);
        });
    }
  }

  setCurrentDate(date) {
    this.setState({currentDate: date}, () => {
      this.computeDisplayedDateRange();
    });
  }

  setCurrentView(view) {
    this.setState({currentView: view}, () => {
      this.computeDisplayedDateRange();
    });
  }

  computeDisplayedDateRange() {
    const {currentDate, currentView} = this.state;
    let start = moment(currentDate).startOf(currentView);
    let end = moment(currentDate).endOf(currentView);
    if (currentView === 'month') {
      start = start.startOf('week');
      end = end.endOf('week');
    }
    this.setState({dateRange: {start: start, end: end}}, () => {
      if (currentView !== 'month') {
        start = start.startOf('week');
        end = end.endOf('week');
      }
      // console.log("Start", (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start) - 24 * 3600);
      // console.log("End", (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000)) - 24 * 3600);
      if (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start < (32 * 24 * 3600)) {
        const rangeStart = Math.round(start.toDate().getTime() / 1000) - (90 * 24 * 3600);
        const rangeEnd = rangeStart + (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      } else if (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000) < (32 * 24 * 3600)) {
        const rangeEnd = Math.round(end.toDate().getTime() / 1000) + (90 * 24 * 3600);
        const rangeStart = rangeEnd - (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      }
    });
  }


  updateData(fetchRange = {}) {
    if (Object.keys(fetchRange).length === 0) {
      fetchRange = this.state.fetchRange;
    }
    var self = this;
    if (!this.state.loading) this.setState({loading: true});
    getData(`events/feed`, fetchRange, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          self.setState({
            events: data.data.events,
            // calendarList: data.data.calendarList,
            dataLoaded: true,
            loading: false,
            fetchRange: {
              ...fetchRange
            }
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  eventStyleGetter(event, start, end, isSelected) {
    var style = {
      backgroundColor: event.eventColor || "",
      color: event.color || "",
      fontSize: 10,
      zIndex: 100
    };
    return {
      style: style
    };
  }

  addSelection(selection) {
    // console.log({start: selection.start, end: selection.end});
    // EventClient.emit("EVENT_ENTRY_ADD", {addSelection: {start: selection.start, end: selection.end}})
    this.setState({addSelection: {start: selection.start, end: selection.end}, showAddEventEntry: true})
  }

  render() {
    let self = this;
    const eventStart = function (event) {
      return forceUTCTimeZone(formatUTCTimeFromEpoch(event.start));
    };
    const eventEnd = function (event) {
      return forceUTCTimeZone(formatUTCTimeFromEpoch(event.end));
    };
    const titleAccessor = function (event) {
      return (Number(event.allDay) === 0 ? displayMilHoursMinutesFromTime(eventStart(event)) + " " : "") + event.title;
    };
    const agendaTitleAccessor = function (event) {
      return <div style={{cursor: "pointer"}}
                  onClick={() => self.setState({chosenEvent: event.id})}>{titleAccessor(event)}</div>;
    };

    const dateFilter = function (events) {
      if (self.state.dateRange.start > 0 && self.state.dateRange.end > 0) {
        // return events
        return events.filter((event) => (event.start >= (self.state.dateRange.start.toDate().getTime() / 1000) && event.start <= (self.state.dateRange.end.toDate().getTime() / 1000)));
      } else {
        return events;
      }
    }

    return (
      <div className="animated fadeIn">
        <LoadingDialog isOpen={this.state.loading}/>
        {this.state.dataLoaded && (
          <Card>
            <CardHeader style={{display: 'inherit'}}>
              <i className="icon-calendar"></i>
              Event Calendar
              <div className="card-actions">
                <button onClick={() => this.setState({showAddEventEntry: true, addSelection: {}})}>
                  <small className="text-muted">Add</small>
                </button>
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              <BigCalendar className="d-sm-down-none"
                           localizer={localizer}
                           views={['month', 'week', 'day', 'agenda']}
                           events={dateFilter(this.state.events)}
                           step={30}
                           popup
                           defaultDate={new Date()}
                           defaultView='month'
                           toolbar={true}
                           selectable={true}
                           eventPropGetter={this.eventStyleGetter}
                           onSelectEvent={(event) => this.setState({chosenEvent: event})}
                           startAccessor={eventStart}
                           endAccessor={eventEnd}
                           titleAccessor={titleAccessor}
                // onClick={console.log}
                // onEventResize={console.log}
                           draggableAccessor={event => false}
                           onNavigate={(date) => this.setCurrentDate(date)}
                           onView={(view) => this.setCurrentView(view)}
                           onSelectSlot={(selection) => this.addSelection(selection)}
                           style={{height: '50em'}}
              />
              <BigCalendar className="d-md-none"
                           localizer={localizer}
                           views={['agenda']}
                           events={dateFilter(this.state.events)}
                           step={30}
                           popup
                           defaultDate={new Date()}
                           defaultView='agenda'
                           toolbar={true}
                           selectable={true}
                           eventPropGetter={this.eventStyleGetter}
                           onSelectEvent={(event) => this.setState({chosenEvent: event})}
                           startAccessor={eventStart}
                           endAccessor={eventEnd}
                           titleAccessor={agendaTitleAccessor}
                // onClick={console.log}
                // onEventResize={console.log}
                           draggableAccessor={event => true}
                           onNavigate={(date) => this.setCurrentDate(date)}
                           onView={(view) => this.setCurrentView(view)}
                           onSelectSlot={(selection) => this.addSelection(selection)}
                           style={{height: '30em'}}
              />
            </CardBody>
          </Card>
        )}
        {(this.state.showAddEventEntry || isNumber(this.state.chosenEvent && this.state.chosenEvent.id)) && (
          <MakeDialog isOpen={true}
                      size={"modal-lg"}
                      header="Event Entry">
            <EventEntryEditor addSelection={this.state.addSelection}
                              saveEvent={"EVENT_SAVE"}
                              eventName={"EventEntryEditor"}
                              edit={this.state.chosenEvent && this.state.chosenEvent.id || "add"}
                              onSave={() => EventClient.emit("EVENT_REFRESH") || this.setState({
                                showAddEventEntry: false,
                                chosenEvent: null
                              })}
                              footer={<Fragment>

                                {!this.state.showAddEventEntry && (
                                  <div style={{marginRight: 100}}>
                                    <Button color="info"
                                            onClick={() => this.setState({
                                              showAddEventEntry: true,
                                              chosenEvent: null
                                            })}>Duplicate</Button>
                                    {hasPermission(RequiredPermission.EventRemove) && (
                                      <Button color="danger"
                                              onClick={() => this.removeEvent(this.state.chosenEvent)}>Delete</Button>
                                    )}
                                  </div>
                                )}

                                <Button color="primary"
                                        onClick={() => EventClient.emit("EVENT_SAVE", {})}>Save</Button>
                                <Button color="secondary"
                                        onClick={() => EventClient.emit("EVENT_REFRESH") || this.setState({
                                          showAddEventEntry: false,
                                          chosenEvent: null
                                        })}>Close</Button>
                              </Fragment>}
            />
          </MakeDialog>
        )}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/containers/Events/Events.js